import { Vector3 } from '@babylonjs/core';

/** Camera state during gameplay. */
export enum CameraState {
	Idle,
	FollowingBall,
}

type CameraConfig = {

	/** Horizontal rotation angle (around Y axis). */
	readonly alpha: number;

	/** Vertical rotation angle (elevation). */
	readonly beta: number;

	/** Distance from target. */
	readonly radius: number;

	/** Point camera looks at. */
	readonly target: Vector3;

	/** Minimum allowed zoom distance. */
	readonly minRadius: number;

	/** Maximum allowed zoom distance. */
	readonly maxRadius: number;

	/** Minimum elevation angle (prevents looking too low). */
	readonly minBeta: number;

	/** Maximum elevation angle (prevents looking too high). */
	readonly maxBeta: number;

	/** Camera movement smoothness (0 = instant, 1 = very smooth). */
	readonly inertia: number;
};

type BallFollowConfig = {

	/** Interpolation speed for smooth following (0.01 = very smooth). */
	readonly lerpSpeed: number;

	/** Optimal distance from ball during following. */
	readonly followRadius: number;
};

/**
 * Initial camera configuration.
 * Defines default camera position and constraints for gameplay.
 */
export const INITIAL_CAMERA_CONFIG: CameraConfig = {
	alpha: Math.PI + 0.1,
	beta: Math.PI / 2.6,
	radius: 20,
	target: new Vector3(0, 0, 0),
	minRadius: 10,
	maxRadius: 50,
	minBeta: 0.1,
	maxBeta: Math.PI / 2.1,
	inertia: 0.9,
} as const;

/**
 * Ball following behavior configuration.
 * Controls smooth camera following during ball flight.
 */
export const BALL_FOLLOW_CONFIG: BallFollowConfig = {
	lerpSpeed: 0.01,
	followRadius: 30,
} as const;
